export const currentDateAsString = (): string => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Ensure two digits
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();

    return `${day}/${month}/${year}`;
};

export const extractAndConvertFrom = (dateTime: string) => {
    if (!dateTime) {
        return '';
    }
    return dateTime.split(' ')[0].split('-').reverse().join('/');
};

export const isDatePast = (dateString: string) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const inputDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    return inputDate < today;
};

export const formatDateToBR = (date: string | null | undefined): string => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR');
};

export const formatDateFromBRToISO = (dateString: string): string => {
    if (!dateString)
        return '';
    const [day, month, year] = dateString.split('/');
    if (!day || !month || !year)
        return '';
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}